<template>
  <a-modal
    v-model="visible"
    :title="`${formIsEdit ? $t('interface_edit_title') : $t('interface_add_title')} `"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    @ok="formSubmitConfirm"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    centered
  >
    <a-form-model
      :model="form"
      :rules="formRules"
      ref="formElement"
      :labelCol="{ span: 6 }"
      :wrapperCol="{ span: 18 }"
    >
      <!-- 父级菜单 -->
      <a-form-model-item :label="$t('menu_interface_form_menu')" prop="menuId">
        <a-tree-select
          v-model="form.menuId"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="allMenu"
          :placeholder="$t('menu_interface_form_menu_placeholder')"
          tree-default-expand-all
          ref="parentMenu"
        >
        </a-tree-select>
      </a-form-model-item>

      <!-- 名称 -->
      <a-form-model-item :label="$t('interface_form_name')" prop="name">
        <a-input
          v-model="form.name"
          :placeholder="$t('interface_form_name_placeholder')"
          allowClear
          @input="formInput"
          style="width:350px"
          ref="interfaceMenu"
        />
      </a-form-model-item>

      <!-- Auth Name -->
      <a-form-model-item :label="$t('menu_interface_form_auth_name')" prop="authName">
        <a-input
          v-model="form.authName"
          :placeholder="$t('menu_interface_form_auth_name_placeholder')"
          allowClear
          @input="formInput"
          style="width:350px"
        />
      </a-form-model-item>

      <!-- url -->
      <a-form-model-item :label="$t('menu_interface_form_url')" prop="url">
        <a-input
          v-model="form.url"
          :placeholder="$t('interface_form_url_placeholder')"
          allowClear
          @input="formInput"
          style="width:350px"
        />
      </a-form-model-item>

      <!-- Methods -->
      <a-form-model-item :label="$t('interface_form_method')" prop="method">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.method"
          :placeholder="$t('interface_form_method_placeholder')"
          style="min-width:180px;"
        >
          <a-select-option value="GET">GET</a-select-option>
          <a-select-option value="POST">POST</a-select-option>
          <a-select-option value="Delete">Delete</a-select-option>
          <a-select-option value="PUT">PUT</a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 通用 -->
      <a-form-model-item
        :label="$t('menu_interface_form_auth_common')"
        prop="common"
        :help="$t('menu_interface_form_auth_common_help')"
      >
        <a-checkbox v-model="form.common"></a-checkbox>
      </a-form-model-item>

      <!-- 禁用 -->
      <a-form-model-item :label="$t('com_form_disabled')" prop="disabled">
        <a-switch v-model="form.disabled" />
      </a-form-model-item>

      <!-- 描述 -->
      <a-form-model-item :label="$t('com_form_remark')" prop="remark" style="margin:0">
        <a-textarea
          v-model="form.description"
          :placeholder="$t('com_form_remark_placeholder')"
          :rows="3"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/role';

export default {
  props: {
    allMenu: {
      type: Array,
      default: () => [],
    },
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      interfaceInfo: null,
      // 新增
      visible: false,
      formRules: {
        menuId: [
          {
            required: true,
            message: this.$t('interface_form_parent_menu_placeholder'),
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: this.$t('interface_form_name_placeholder'),
            trigger: 'change',
          },
        ],
        authName: [
          {
            required: true,
            message: this.$t('interface_form_auth_name_placeholder'),
            trigger: 'change',
          },
        ],
        url: [
          {
            required: true,
            message: this.$t('interface_form_url_placeholder'),
            trigger: 'change',
          },
        ],
        method: [
          {
            required: true,
            message: this.$t('interface_form_method_placeholder'),
            trigger: 'change',
          },
        ],
      },
      // 搜索
      form: {
        menuId: null,
        // 名称
        name: undefined,
        // 权限值
        authName: undefined,
        common: undefined,
        // 是否禁用
        disabled: false,
        // 是否隐藏
        hide: false,
        // 父级菜单
        method: undefined,
        // 备注
        description: undefined,
        // URL
        url: undefined,
      },
      formError: '',
      formIsEdit: '',
      formLoading: false,
    };
  },
  methods: {
    // 更新列表
    updateList() {
      // 更新列表
      this.callback();
    },

    // Role - 显示
    show(interfaceInfo, currentMenu) {
      this.visible = true;
      this.formIsEdit = interfaceInfo ? true : false;
      this.interfaceInfo = interfaceInfo;

      // focus name
      this.$nextTick(() => {
        this.$refs.interfaceMenu && this.$refs.interfaceMenu.focus();

        if (this.formIsEdit) {
          // 编辑
          Object.keys(this.form).forEach(key => {
            this.form[key] = interfaceInfo[key];
          });
        } else {
          this.formReset();
          if (currentMenu) {
            this.form.menuId = currentMenu.id;
          }
        }
      });
    },

    // 提交确认，主要针对通用权限有勾选的接口
    formSubmitConfirm() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          if (this.form.common) {
            const h = this.$createElement;
            this.$confirm({
              title: this.$t('com_btn_confirm'),
              content: h('div', {}, [h('p', this.$t('interface_confirm_auth_access_tip'))]),
              centered: true,
              onOk: () => {
                this.formSubmit();
              },
            });
          } else {
            this.formSubmit();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 菜单添加 - 提交
    formSubmit() {
      const params = { ...this.form };
      this.formLoading = true;
      if (this.formIsEdit) {
        params.id = this.interfaceInfo.id;
        // 编辑
        API.InterfaceEdit(params)
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t('com_msg_edit_success'));
              this.visible = false;
              this.formReset();
              // 更新列表
              this.updateList();
            } else {
              this.formError = res.message;
            }
          })
          .finally(() => {
            this.formLoading = false;
          });
      } else {
        API.InterfaceAdd(params)
          .then(res => {
            if (res.code === 0) {
              this.$message.success(this.$t('com_msg_add_success'));
              this.visible = false;
              this.formReset();
              // 更新列表
              this.updateList();
            } else {
              this.formError = res.message;
            }
          })
          .finally(() => {
            this.formLoading = false;
          });
      }
    },
    // Role - error reset
    formInput() {
      this.formError = '';
    },
    // Role - add form reset
    formReset() {
      this.$refs.formElement.resetFields();
      Object.keys(this.form).forEach(key => {
        if (key === 'disabled') {
          this.form[key] = false;
        } else if (key === 'hide') {
          this.form[key] = false;
        } else {
          this.form[key] = undefined;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
